import { useSelector } from 'react-redux';
import { RootState } from 'redux/types';

const getUser = (store: RootState) => store.user.user;
export const useSelectUser = () => useSelector(getUser);
